import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type BillReleaseLinkedModalContext = {
  partySide: "customer" | "vendor";
  partyId: string;
  documentNo: string;
  documentType: string;
  partyName?: string;
  rowData?: Record<string, unknown>;
};

export interface BillReleaseLinkedModalState {
  isOpen: boolean;
  context: BillReleaseLinkedModalContext | null;
}

const initialState: BillReleaseLinkedModalState = {
  isOpen: false,
  context: null,
};

const billReleaseLinkedModalSlice = createSlice({
  name: "billReleaseLinkedModal",
  initialState,
  reducers: {
    openBillReleaseLinkedModal: (
      state,
      action: PayloadAction<BillReleaseLinkedModalContext>
    ) => {
      state.isOpen = true;
      state.context = action.payload;
    },
    closeBillReleaseLinkedModal: (state) => {
      state.isOpen = false;
      state.context = null;
    },
  },
});

export const { openBillReleaseLinkedModal, closeBillReleaseLinkedModal } =
  billReleaseLinkedModalSlice.actions;

export default billReleaseLinkedModalSlice.reducer;
